export default {
  primary: '#133671',
  light: '#fff',
  dark: '#333',
  darkOpacity: 'rgba(0, 0, 0, 0.3)',
  secondary: '#eeeeee',
  tertiary: '#e0e0e0',
};
